<template>
  <b-modal
    :id="`modal-edit-invoice-number${id}`"
    centered
    size="md"
    title="修改發票號碼"
    hide-footer
    @hide="resetModal"
  >
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col cols="12">
              <validation-provider
                #default="validationContext"
                name="發票號碼"
                rules="required"
              >
                <b-form-group
                  label="發票號碼"
                  label-for="invoice_number"
                  class="required"
                >
                  <b-form-input
                    id="invoice_number"
                    v-model="invoiceData.invoice_number"
                    :state="getValidationState(validationContext)"
                    placeholder="請輸入發票號碼"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" class="text-center mt-2">
              <b-button variant="primary" class="mr-1" type="submit">
                儲存
              </b-button>
              <b-button variant="outline-secondary" @click="hide">
                取消
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BOverlay,
  BRow,
  BCol,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import store from "@/store";

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BOverlay,
    BRow,
    BCol,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    invoiceId: {
      type: Number,
      required: false,
      default: null,
    },
    currentInvoiceNumber: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      invoiceData: {
        id: this.invoiceId || null,
        invoice_number: this.currentInvoiceNumber || "",
      },
    };
  },
  watch: {
    currentInvoiceNumber: {
      immediate: true,
      handler(newVal) {
        this.invoiceData.invoice_number = newVal;
      },
    },
    invoiceId: {
      immediate: true,
      handler(newVal) {
        this.invoiceData.id = newVal;
      },
    },
  },
  methods: {
    hide() {
      this.$bvModal.hide(`modal-edit-invoice-number${this.id}`);
    },
    resetModal() {
      this.$nextTick(() => {
        this.invoiceData = {
          id: this.invoiceId,
          invoice_number: this.currentInvoiceNumber,
        };
      });
    },
    onSubmit() {
      this.$swal({
        title: "確認修改發票號碼?",
        showCancelButton: true,
        confirmButtonText: "確認",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("invoice/updateInvoiceNumber", this.invoiceData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const { refFormObserver, getValidationState } = formValidation();
    return {
      refFormObserver,
      getValidationState,
    };
  },
};
</script>
